export default "__VITE_ASSET__2ea64d0e__"